<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section  class="invoice-preview-wrapper" v-if="transactionDetails && !isEmpty(transactionDetails)">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                      </div>
<!--                      <p v-if="transactionDetails.payment_method" class="card-text mb-25">Payment Method: {{ transactionDetails.payment_method?transactionDetails.payment_method.name:'N/A' }}</p>-->
                      <p class="card-text mb-25">Gateway Ref Id:
                        {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}</p>
                      <p class="card-text mb-0">Transaction Type: {{ transactionDetails.transaction_type.name }}</p>
                      <p class="card-text mb-0" v-if="transactionDetails.settlement_status == 1">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-info">INITIATED</span></p>
                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 2">Settlement Status: <span class="badge badge-pill mt-1  badge-glow badge-danger">CANCELED</span></p>
                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 3">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-success">DONE</span></p>
                      <p class="card-text mb-0" v-else>Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-warning">PENDING</span></p>
                      <p class="card-text mb-25" v-if="transactionDetails.status == 1">Transaction Status:  <span class="badge  mt-1  badge-glow badge-info">Success</span></p>
                      <p class="card-text mb-25" v-else-if="transactionDetails.status == 2">Transaction Status: <span class="badge  mt-1  badge-glow badge-danger">Failed</span></p>
                      <p class="card-text mb-25" v-else> Transaction Status:  <span class="badge  mt-1  badge-glow badge-warning">PENDING</span></p>
                      <p class="card-text mb-25 mt-1">Aquiring: {{ transactionDetails.aquiring?transactionDetails.aquiring.name+'/'+transactionDetails.aquiring.code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Schema: {{ transactionDetails.schema?transactionDetails.schema.name+'/'+transactionDetails.schema.code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Country: {{ transactionDetails.country_code?transactionDetails.country_code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1">Approval Code: {{ transactionDetails.approval_code?transactionDetails.approval_code:'N/A' }}</p>
                      <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.client_reference) != 'undefined'">Client Reference: {{ transactionDetails.client_reference?transactionDetails.client_reference:'N/A' }}</p>
                    </div>
                    <div class="mt-md-0 mt-2">
                      <h4 class="invoice-title">
                        Transaction
                        <span class="invoice-number">#{{$route.params.id}}</span>
                      </h4>
                      <div class="invoice-date-wrapper justify-content-end">
                        <p class="invoice-date-title">Date Created:</p>
                        <p class="invoice-date">{{
                                new Date(transactionDetails.created_at).toISOString().slice(0, 16).replace('T', ' ')
                          }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Header ends -->
                  <div class="alert alert-danger mt-1" role="alert" v-if="transactionDetails.status ==2 && typeof(transactionDetails.failureReason) != 'undefined' && Object.keys(transactionDetails.failureReason).length != 0">
                    <h4 class="alert-heading">Failure Reason</h4>
                    <div class="alert-body">
                      {{transactionDetails.failureReason.reason?transactionDetails.failureReason.reason:'N/A'}}
                    </div>
                  </div>
                </div>


                <hr class="invoice-spacing"/>


                <div class="card-body invoice-padding pt-0">
                  <div class="row invoice-spacing">
                    <div class="col-xl-8 p-0">
                      <h6 class="mb-2">Sender Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.sender.first_name + ' '+ transactionDetails.sender.last_name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.sender.email}} </p>
                      <p class="card-text mb-25">Account title: {{transactionDetails.sender_account_title}}</p>
                      <p class="card-text mb-25">Account Number: {{transactionDetails.sender_account_number}}</p>
                      <p class="card-text mb-25">Customer Email: {{transactionDetails.customer?transactionDetails.customer.email:'N/A'}}</p>
                      <p class="card-text mb-25">Customer Name: {{transactionDetails.customer?transactionDetails.customer.name:'N/A'}}</p>
                      <p class="card-text mb-25">Customer Phone: {{transactionDetails.customer?transactionDetails.customer.phone:'N/A'}}</p>
                    </div>
                    <div class="col-xl-4 p-0 mt-xl-0 mt-2">
                      <h6 class="mb-2">Receiver Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.receiver.first_name + ' '+ transactionDetails.receiver.last_name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.receiver.email}} </p>
                      <p class="card-text mb-25">Account title: {{transactionDetails.receiver_account_title}}</p>
                      <p class="card-text mb-25">Account Number: {{transactionDetails.receiver_account_number}}</p>
                    </div>
                  </div>
                </div>


                <div class="card-body invoice-padding pb-0 mt-5">
                  <div class="row invoice-sales-total-wrapper">
                    <div class="col-md-4 order-md-1 order-2 mt-md-0 mt-3">

                    </div>
                    <div class="col-md-8 d-flex justify-content-end order-md-2 order-1">
                      <div class="invoice-total-wrapper">
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Actual Amount:</p>
                          <p class="invoice-total-amount" v-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat(transactionDetails.total_amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                          <p class="invoice-total-amount" v-else>{{ parseFloat(transactionDetails.amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Vat:</p>
                          <p class="invoice-total-amount">
                            {{ parseFloat(transactionDetails.vat / 100).toFixed(feesDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Fee:</p>
                          <p class="invoice-total-amount">
                            {{ parseFloat(transactionDetails.fee / 100).toFixed(feesDecimalPlaces)+ ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                        <hr class="my-50"/>
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Payable Amount:</p>
                          <p class="invoice-total-amount text-danger" v-if="transactionDetails.transaction_type_id == 6">- {{parseFloat((parseFloat(transactionDetails.amount)+parseFloat(transactionDetails.vat)+parseFloat(transactionDetails.fee))/100).toFixed(amountDecimalPlaces
                          ) + ' ' + transactionDetails.currency.code }}</p>
                          <p class="invoice-total-amount" v-else-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat((transactionDetails.amount) / 100).toFixed(amountDecimalPlaces
                          ) + ' ' + transactionDetails.currency.code  }}</p>
                          <p class="invoice-total-amount" v-else>{{ parseFloat((transactionDetails.amount - transactionDetails.vat - transactionDetails.fee) / 100).toFixed(amountDecimalPlaces
                          ) + ' ' + transactionDetails.currency.code  }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <hr class="invoice-spacing"/>


              </div>
            </div>
            <!-- /Invoice -->

          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['propFilters'],
  mounted() {
    this.getTransactionsDetails()
  },
  data() {
    return {
      previousRoute:null,
      transactionDetails: [],
      breadcrumb: [
        {name: 'App'},
        {name: 'Transactions'},
        {name: 'Details'},
      ],

    }
  },
  methods: {
    backTo(){
      if(this.previousRoute){
        if(this.previousRoute == 'transactions'){
          let propFilters = this.propFilters
          if(typeof(this.$route.query.tab) != 'undefined'){
            this.$router.push({name:'transactions',query: { tab: this.$route.query.tab },params:{propFilters}})
          }else{
            this.$router.push({name:'transactions',params:{propFilters}})
          }
        }else{
          this.$router.back()
        }
      }else{
        this.$router.back()
      }

    },
    getTransactionsDetails() {
      let data = {
        transactionId: this.$route.params.id,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transactions", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.transactionDetails = responseData
              }
            }
          }
      );
    }
  },
  beforeRouteEnter(to, from, next) {



    next(vm => vm.previousRoute = from.name)
  }

}
</script>


